import React, { useEffect, useState } from 'react';
import { AiOutlineClose, AiOutlineMenu, AiOutlineTeam } from 'react-icons/ai';

import { NavLink } from 'react-router-dom';
import { MdDashboard } from "react-icons/md";
import { RiTeamFill } from "react-icons/ri";
import { CiLink } from "react-icons/ci";
import { TfiStatsUp } from "react-icons/tfi";
import { ConnectButton } from '@rainbow-me/rainbowkit';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import { setUserData, setUserActivityData, setPartnersTableData, setUserInputid, setselectedComponent } from '../Store/UserSlice'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import BrandLogo from '../../asstes/logo.jpg'
import { FaSearch } from 'react-icons/fa';

const ReferalNavBar = () => {

    const [nav, setNav] = useState(false);
    const ApiUrl = process.env.REACT_APP_API;
    const ClickUserState = useSelector(state => state.user.ClickUserState)
    const ClickUserId = useSelector(state => state.user.ClickUserId)
    console.log("ClickUserId", ClickUserId, ClickUserState)


    const navItems = [
        {
            id: " Preview ID1701890", input: <input type="text" id="full-name"
                value={1701890} readOnly name="full-name"
                className=" mt-3 block md:hidden md:w-1/2 lg:w-2/3 w-[70%]
                bg-blue-500 rounded-lg focus:border-4 border-none
                text-base outline-none text-white py-2 px-3 leading-8 transition-colors 
                duration-200 ease-in-out" />,
            goButton: <button className='py-3 bg-blue-500 rounded-lg px-10  text-white'>Go</button>,
            exitButton: <button className='py-3 bg-black w-full hover:bg-[#333] rounded-lg px-10  text-white'>Exit preview mode</button>,
        },

        { dashboardText: "Dashboard", dashboardIcon: <MdDashboard size={25} /> },
        { teamText: "Team", teamIcons: <RiTeamFill size={25} /> },
        { link: "Partners", icons: <AiOutlineTeam size={25} /> },
        { link: "Links", icons: <CiLink size={25} /> },
        { link: "Stats", icons: <TfiStatsUp size={25} /> },
    ]

    const handleNav = () => {
        setNav(!nav);
    };

    const HandelCloseNavbar = () => {
        dispatch(setselectedComponent("Dashbord"));
    }

    ////////////////////////////////////////////////////////
    const dispatch = useDispatch()

    const [Previewid, setPreviewid] = useState(null)
    const inpututValue = Previewid ? Previewid : ClickUserId
    dispatch(setUserInputid(ClickUserId))
    console.log("Preview ID", Previewid)

    const GetUserData = async (id) => {
        if (id !== null) {
            console.log("iddddddddddddddddddd", id)
            // updateURL(id);
            try {
                const response = await axios.get(`${ApiUrl}/users/user-data/${id}`)
                console.log("ClickUserId res", response)
                dispatch(setUserData(response.data))
                GetPartnersData(id)
            } catch (error) {
                console.log(error, "user data Error")
                toast.error(error.response.data.error);

            }
        } else {
            toast.error('Plese Enter User Id Then Search!');
        }
    }



    const updateURL = (newUserId) => {
        const pathname = window.location.pathname;
        if (pathname.includes('userId=')) {
            const newURL = pathname.replace(/userId=\d+/, `referalcode=${newUserId}`);
            window.history.pushState({}, '', newURL);
        } else {
            const newURL = `${pathname}/userId=${newUserId}`;
            window.history.pushState({}, '', newURL);
        }
    };


    const getUserIdFromURL = () => {
        const pathname = window.location.pathname;
        const parts = pathname.split('/');
        const lastPart = parts[parts.length - 1];
        const userId = lastPart.split('=')[1];
        return userId;
    };
    // Example usage:
    let userIdfromurl = getUserIdFromURL();



    //User Activity APi Call
    const GetUserActivty = async () => {
        try {
            const response = await axios.get(`${ApiUrl}/users/new-activity`)
            console.log("activit", response.data)
            dispatch(setUserActivityData(response.data))

        } catch (error) {
            console.log("error", error)
        }
    }


    const GetPartnersData = async (id) => {
        try {
            const response = await axios.get(`${ApiUrl}/users/partners/${id}`)
            console.log("PartnersData", response)
            dispatch(setPartnersTableData(response.data.partners))

        } catch (error) {
            console.log("error", error)
        }
    }


    const KeyDown = (e) => {
        if (e.key === "Enter") {

            GetUserData(Previewid);
            dispatch(setUserInputid(Previewid))
            dispatch(setselectedComponent("Dashbord"));
        }
    }


    useEffect(() => {
        GetUserActivty()
        // GetUserData(userIdfromurl || 1  )
        GetUserData(userIdfromurl ? userIdfromurl : 1)
        dispatch(setUserInputid(1))
    }, [])

    useEffect(() => {
        if (ClickUserState) {
            GetUserData(ClickUserId)
            // console.log("ClickUserId", ClickUserId, ClickUserState)
            // updateURL(ClickUserId);
            setPreviewid(null)
        }
    }, [ClickUserId, ClickUserState])

    return (
        <>
            <ToastContainer
                position="bottom-right"
                autoClose={2000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                // pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="light"
            />
            <div className="Nav_section fixed mb-6 bg-[#111111] w-full">
                <div className='Brqan '> <img src={BrandLogo} width={"170px"} className='Brand_logo' /> </div>
                <div className='  w-full'>
                    <div className='nav_bar_background  NavBar_Border  lg:mt-4 md:mt-4 lg:ml-8  md:w-[95%] md:mx-auto md:ml-5   shadow-xl fixed  lg:w-[78%] right-4  top-0 z-10 w-full flex justify-between items-center h-16  rounded-b-lg md:rounded-lg lg:rounded-lg  mx-auto px-4 text-black  '>
                        {/* Desktop Navigation */}
                        <div className=' w-full flex md:justify-between  justify-between items-center '>
                            <div className='flex w-2/2 md:w-2/3 lg:w-[45%] justify-between gap-6  items-center'>
                                <NavLink to="/">
                                    <h3 className='text-white text-xl font-bold'  >

                                        {/* Web Tech */}
                                        {/* <img src={BrandLogo} width={"100px"} className='Brand_logo'/> */}

                                    </h3>
                                </NavLink>
                                <p className='flex font-medium  text-white'>Referal ID</p>
                                <div className='flex gap-5'>
                                <input type="text" id="full-name"
                                    placeholder='Enter Referal Code...'
                                    value={inpututValue}
                                    onChange={(e) => setPreviewid(e.target.value)} name="full-name"
                                    onKeyDown={(e) => KeyDown(e)}
                                    className=" hidden 
                            md:block lg:block md:w-[100%] lg:w-[100%] w-[100%]  bg-white rounded-lg focus:border-4 border-none text-base outline-none text-black py-2 px-3 leading-8 transition-colors duration-200 ease-in-out " />

                                <button className='py-4 md:hidden hidden lg:block bg-[white] rounded-lg px-5  text-black button-name' onClick={() => GetUserData(Previewid)} ><FaSearch  color='black'/></button>
                                </div>
                            </div>
                            <div className=' justify-around gap-8 items-center hidden md:flex'>
                                <span className='font-bold  rounded-lg py-3 px-4'><ConnectButton color="red" /></span>
                                <NavLink to="/" onClick={HandelCloseNavbar}>
                                    {/* <button className='font-bold bg-[white]  rounded-full p-2 Close_btn_navbar'><AiOutlineClose size={25} color='black'  /></button> */}
                                </NavLink>

                            </div>
                        </div>
                        {/* Mobile Navigation Icon */}
                        <div onClick={handleNav} className='block md:hidden p-2 cursor-pointer hover:bg-blue-400 rounded-full  bg-blue-500'>
                            {nav ? "" : <AiOutlineMenu size={25} />}
                        </div>

                        {/* Mobile Navigation Menu */}
                        <ul
                            className={
                                nav
                                    ? 'fixed md:hidden left-0 top-0 w-[100%] h-full  bg-blue-600 ease-in-out duration-300'
                                    : 'ease-in-out w-[100%] duration-300 fixed top-0 bottom-0 left-[-100%]'
                            }
                        >
                            {/* Mobile Logo */}
                            <div className='flex justify-between'>
                                <h1 className='w-full text-xl font-bold text-[#fff] m-4'>FORSAGE</h1>
                                <div onClick={handleNav} className='block md:hidden my-4 mr-4 rounded-full p-2 bg-blue-500 hover:bg-blue-400 cursor-default'>
                                    {nav ? <AiOutlineClose size={25} /> : ""}
                                </div>
                            </div>



                            {/* Mobile Navigation Items */}
                            {navItems.map((item, index) => (
                                <div key={index}>
                                    <li className='px-5 text-2xl font-medium'>{item.id}</li>
                                    <li className='px-5 py-6 flex items-center gap-8'>{item.input} <p className='mt-3'>{item.goButton}</p></li>
                                    <li className='px-5'>{item.exitButton}</li>
                                    <li className=' flex items-center gap-3  px-5 text-white '>
                                        {item.dashboardIcon}
                                        <span className=' font-medium border-b  border-b-white  '>{item.dashboardText}</span>
                                    </li>
                                    <li className=' flex items-center gap-3  px-5 text-gray-400 '>
                                        {item.teamIcons}
                                        <span className=' '>{item.teamText}</span>
                                    </li>
                                    <li className='flex items-center gap-3 px-14 text-gray-400'>
                                        <p>{item.icons}</p>
                                        <p>{item.link}</p>
                                    </li>
                                </div>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ReferalNavBar;